import { render, staticRenderFns } from "./MaterialProject.vue?vue&type=template&id=7c4d5746&scoped=true&"
import script from "./MaterialProject.vue?vue&type=script&lang=js&"
export * from "./MaterialProject.vue?vue&type=script&lang=js&"
import style0 from "./MaterialProject.vue?vue&type=style&index=0&id=7c4d5746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d5746",
  null
  
)

export default component.exports